module.exports = __webpack_public_path__ + "static/media/galleryGT (20).841be4bc.jpg";